import BlurOnOutlinedIcon from '@mui/icons-material/BlurOnOutlined';

/**
 * Alopecia areata: padrão clínico da perda de cabelo, de placa única a perda
 * em todo o corpo. Referência clínica: padrões clássicos descritos em
 * Alkhalifah A et al. (J Am Acad Dermatol, 2010;62:177-88) e em StatPearls,
 * "Alopecia Areata" (NCBI Bookshelf). A extensão (escala SALT) fica fora
 * deste módulo. Textos nossos.
 *
 * Os valores precisam ser os mesmos de public/api/scales/catalog/alopecia_areata.php.
 */
const alopeciaAreata = {
  key: 'alopecia_areata',
  name: 'Alopecia areata: padrão',
  description: 'Padrão da perda: placas, ofíase, total, universal ou difusa',
  details: 'Registra o padrão clínico da alopecia areata, da placa única até a perda de todos os pelos do corpo, passando pelas formas em faixa (ofiásica e sisaifo) e pela difusa. O padrão ajuda a estimar o prognóstico e a escolher o tratamento. A extensão da área afetada (escala SALT) não é registrada aqui. Um clique marca o padrão do atendimento, o card mostra o da última consulta e a aba Saúde guarda a evolução.',
  kind: 'single',
  icon: BlurOnOutlinedIcon,
  accent: 'purple',
  options: [
    { value: 'unifocal', label: 'Unifocal', image: 'alopecia-areata-1.png', help: 'Uma única placa arredondada sem cabelo, de pele lisa.' },
    { value: 'multifocal', label: 'Multifocal', image: 'alopecia-areata-2.png', help: 'Várias placas separadas, que podem crescer e se juntar.' },
    { value: 'ophiasis', label: 'Ofiásica', image: 'alopecia-areata-3.png', help: 'Perda em faixa na nuca e acima das orelhas, contornando a borda do couro cabeludo. Costuma responder pior ao tratamento.' },
    { value: 'sisaipho', label: 'Sisaifo', caption: 'Ofíase inversa', image: 'alopecia-areata-4.png', help: 'Perda no topo e no centro da cabeça, poupando a borda. Pode lembrar a calvície de padrão.' },
    { value: 'totalis', label: 'Total', image: 'alopecia-areata-5.png', help: 'Perda de todo o cabelo do couro cabeludo.' },
    { value: 'universalis', label: 'Universal', image: 'alopecia-areata-6.png', help: 'Perda de todo o cabelo e dos pelos do corpo, incluindo sobrancelhas e cílios.' },
    { value: 'diffuse', label: 'Difusa', image: 'alopecia-areata-7.png', help: 'Afinamento espalhado por todo o couro cabeludo, sem placas definidas. Pode ser confundida com eflúvio.' },
  ],
};

export default alopeciaAreata;
